export var randomFromMathRandom = function (n) {
    /* tslint:disable-next-line:strict-type-predicates */
    return n !== undefined ? Math.floor(Math.random() * n) : Math.random();
};
export function createDetermenisticRandom(randomValues) {
    var randomId = -1;
    var random = function (n) {
        if (n === undefined) {
            throw new Error("todo this test");
        }
        randomId++;
        if (randomId >= randomValues.length) {
            throw new Error("Lots of randoms");
        }
        var randomValue = randomValues[randomId];
        if (randomValue >= n) {
            throw new Error("Why stored random value is greater?");
        }
        return randomValue;
    };
    return random;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFuZG9tRnVuYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJhbmRvbUZ1bmMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLElBQU0sb0JBQW9CLEdBQWUsVUFBQyxDQUFDO0lBQ2hELHFEQUFxRDtJQUNyRCxPQUFBLENBQUMsS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFO0FBQS9ELENBQStELENBQUM7QUFFbEUsTUFBTSxVQUFVLHlCQUF5QixDQUFDLFlBQXNCO0lBQzlELElBQUksUUFBUSxHQUFHLENBQUMsQ0FBQyxDQUFDO0lBQ2xCLElBQU0sTUFBTSxHQUFHLFVBQUMsQ0FBcUI7UUFDbkMsSUFBSSxDQUFDLEtBQUssU0FBUyxFQUFFO1lBQ25CLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztTQUNuQztRQUVELFFBQVEsRUFBRSxDQUFDO1FBQ1gsSUFBSSxRQUFRLElBQUksWUFBWSxDQUFDLE1BQU0sRUFBRTtZQUNuQyxNQUFNLElBQUksS0FBSyxDQUFDLGlCQUFpQixDQUFDLENBQUM7U0FDcEM7UUFDRCxJQUFNLFdBQVcsR0FBRyxZQUFZLENBQUMsUUFBUSxDQUFDLENBQUM7UUFFM0MsSUFBSSxXQUFXLElBQUksQ0FBQyxFQUFFO1lBQ3BCLE1BQU0sSUFBSSxLQUFLLENBQUMscUNBQXFDLENBQUMsQ0FBQztTQUN4RDtRQUVELE9BQU8sV0FBVyxDQUFDO0lBQ3JCLENBQUMsQ0FBQztJQUNGLE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUMifQ==